import { Button } from "../Button/Button";
import { Container } from "../Container/Container";
import { Section } from "../Section/Section";
import * as styles from "./CTASection.css";

export function CTASection() {
  return (
    <Section>
      <Container>
        <div className={styles.wrap}>
          <div className={styles.content}>
            <h2 className={styles.title}>Need a practical technical view?</h2>
            <p className={styles.text}>
              Bring us the problem, the system, or the project. We will help you
              understand the options and shape a sensible way forward.
            </p>
            <div className={styles.actions}>
              <Button href="/contact">Discuss a project</Button>
              <Button href="/services" variant="secondary">
                View services
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
